'use client'

import type { RichTextBlockModel } from 'clients/strapi/models/BlockModels'
import type BlogPostVM from 'clients/strapi/models/BlogPostVM'
import TableOfContents from '../TableOfContents/TableOfContents'
import styles from './Sidebar.module.scss'

type Props = { post: BlogPostVM }

const Sidebar = ({ post }: Props) => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.tocWrapper}>
        <TableOfContents block={post.blocks[0] as RichTextBlockModel} />
      </div>
    </div>
  )
}

export default Sidebar
